export const organizationState = {
  data: [],
  hasData: false,
  loading: false,
};

export const initialState = {
  list: organizationState,
};
